export default "* Flyde\n* Synke\n* Tung\n* Let";